export default __webpack_public_path__ + "46fd174d71c574a15de665bebb721418.svg";